module.exports = __webpack_public_path__ + "img/blue_120.3b3b200e.png";